import BentoCard from "cms/components/BentoCard";
import { BentoCardLightMode } from "cms/components/BentoCard/BentoCard.styles";
import MediaQuery from "cms/components/MediaQuery";
import ValuePropositionHeader from "cms/components/ValuePropositionHeader";
import { graphql } from "gatsby";
import React from "react";

import {
  BentoCardsContainer,
  Container,
  Content,
  MordorBentoCardsBlockVariant,
} from "./MordorBentoCardsBlock.styles";

export interface MordorBentoCardsBlockProps
  extends Queries.SanityMordorBentoCardsBlock {}

const MordorBentoCardsBlock: React.FC<MordorBentoCardsBlockProps> = ({
  variant,
  headline,
  _rawDescription,
  bentoCardItems,
  aiLabelText,
  button,
}) => (
  <Container $variant={variant as MordorBentoCardsBlockVariant}>
    <Content>
      {variant === "light" && (
        <MediaQuery $lessThan="large" style={{ width: "100%" }}>
          <ValuePropositionHeader
            headline={headline}
            description={_rawDescription}
            button={button}
          />
        </MediaQuery>
      )}

      {variant === "light" && (
        <MediaQuery
          $greaterThan="large"
          style={{
            width: "100%",
          }}
        >
          <ValuePropositionHeader
            headline={headline}
            description={_rawDescription}
            button={button}
            variant="cursors"
          />
        </MediaQuery>
      )}

      {(variant === "dark" ||
        variant === "darkAutodesigner" ||
        variant === "darkHomepage") && (
        <ValuePropositionHeader
          headline={headline}
          description={_rawDescription}
          button={button}
          variant="magic"
          aiTagText={aiLabelText ?? ""}
        />
      )}

      <BentoCardsContainer $variant={variant as MordorBentoCardsBlockVariant}>
        {bentoCardItems?.map(
          (card: Queries.Maybe<Queries.SanityBentoCardItem>, index) => (
            <BentoCard
              key={index}
              lightMode={variant as BentoCardLightMode}
              card={card}
              className={`card${index + 1}`}
            />
          ),
        )}
      </BentoCardsContainer>
    </Content>
  </Container>
);

export const query = graphql`
  fragment MordorBentoCardsBlock on SanityMordorBentoCardsBlock {
    _key
    _type
    variant
    headline
    _rawDescription(resolveReferences: { maxDepth: 5 })
    aiLabelText
    bentoCardItems {
      variant
      backgroundColor
      title
      _rawCardDescription(resolveReferences: { maxDepth: 5 })
      imageMobile { ...OptimizedImage }
      imageTablet { ...OptimizedImage }
      imageDesktop { ...OptimizedImage }
      imageWideTwo { ...OptimizedImage }
      imagesAlt
    }
    button {
      variant
      label
      url
    }
  }
`;

export default MordorBentoCardsBlock;
